import React, { useEffect, useState } from 'react';
import { i18n_more_info } from '@yi/i18n/phrases/i18n_more_info';

import { addInfoButton } from './addInfoButton';
import { useLocale } from '../../../LocaleProvider';
import { MoreInfoPopover } from '../../../MoreInfoPopover';
import { useMediaPlayer } from '../../MediaPlayerProvider';

type Props = Pick<React.ComponentProps<typeof MoreInfoPopover>, 'description' | 'props'> &
  Partial<Pick<React.ComponentProps<typeof MoreInfoPopover>, 'isAudio'>>;

export const InfoButton: React.FC<Props> = ({ description, isAudio = false, props = null }) => {
  const { player } = useMediaPlayer();
  const { locale } = useLocale();
  const [isMoreInfoOpened, setIsMoreInfoOpened] = useState(false);

  useEffect(() => {
    if (player !== null) {
      addInfoButton(player, {
        title: i18n_more_info(locale),
        onClick: () => {
          setIsMoreInfoOpened(open => !open);
        },
      });
    }
  }, [locale, player]);

  return (
    <MoreInfoPopover
      isAudio={isAudio}
      open={isMoreInfoOpened}
      description={description}
      props={props}
      handleDismiss={() => setIsMoreInfoOpened(false)}
    />
  );
};
